





























import { Component } from 'vue-property-decorator';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import SubTransactionTypeDetails from '@/components/Products/SubTransactionTypes/SubTransactionTypeDetails.vue';

@Component({ name: 'SubTransactionType', components: { Alert, SubTransactionTypeDetails }, metaInfo: { title: 'Sub Transaction Types' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await SubTransactionTypesModule.getSubTransactionType(this.$route.params.id);
    }

    get subTransactionType() {
        return SubTransactionTypesModule.subTransactionType;
    }

    get loading() {
        return SubTransactionTypesModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
